/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeEffectiveFeatureFlagsDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type featureFlagsGetMyFlagsResponse200 = {
  data: ApiEnvelopeEffectiveFeatureFlagsDto
  status: 200
}

export type featureFlagsGetMyFlagsResponse401 = {
  data: ApiEnvelopeEffectiveFeatureFlagsDto
  status: 401
}

export type featureFlagsGetMyFlagsResponseSuccess = (featureFlagsGetMyFlagsResponse200) & {
  headers: Headers;
};
export type featureFlagsGetMyFlagsResponseError = (featureFlagsGetMyFlagsResponse401) & {
  headers: Headers;
};

export type featureFlagsGetMyFlagsResponse = (featureFlagsGetMyFlagsResponseSuccess | featureFlagsGetMyFlagsResponseError)

export const getFeatureFlagsGetMyFlagsUrl = () => {




  return `/api/feature-flags/me`
}

export const useFeatureFlagsGetMyFlagsHook = (): ( options?: RequestInit) => Promise<featureFlagsGetMyFlagsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getFeatureFlagsGetMyFlagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


